import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <p>&copy; 2024 Translator App</p>
    </footer>
  );
}

export default Footer;
